import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-208">
      <div className="max-w-3xl mx-auto" data-id="element-209">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-210">
          El problema que muchos docentes viven cada año
        </h2>

        <p className="text-xl mb-3 font-medium text-center md:text-left" data-id="element-211"></p>

        <ul className="space-y-2 text-lg text-gray-700 mb-5 max-w-2xl mx-auto" data-id="element-212">
          <li className="flex items-start" data-id="element-213">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-214">•</span>
            <span data-id="element-215">Pasás horas buscando efemérides en Internet</span>
          </li>
          <li className="flex items-start" data-id="element-216">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-217">•</span>
            <span data-id="element-218">Tenés material desactualizado</span>
          </li>
          <li className="flex items-start" data-id="element-219">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-220">•</span>
            <span data-id="element-221">Preparás actividades a último momento</span>
          </li>
          <li className="flex items-start" data-id="element-222">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-223">•</span>
            <span data-id="element-224">
              Repetís propuestas porque no hay tiempo para buscar nuevas
            </span>
          </li>
          <li className="flex items-start" data-id="element-225">
            <span className="text-red-500 mr-3 font-bold text-xl" data-id="element-226"></span>
            <span data-id="element-227"></span>
          </li>
        </ul>

        <p className="text-xl text-center mb-3 font-[800] text-[#3CD0E4]" data-id="element-228">
          Lo peor es esa sensación de pensar: "Podría trabajar mejor las
          efemérides… si tuviera todo el material organizado."
        </p>
      </div>
    </section>;
}